export function findActiveBackButton(root) {
  const activeStep = root?.querySelector(".step.active");
  if (!activeStep) return null;

  const buttons = activeStep.querySelectorAll(".layout__back");
  for (const btn of buttons) {
    const layoutStep = btn.closest(".layout__step");
    if (layoutStep && !layoutStep.classList.contains("layout__step--active")) {
      continue;
    }

    if (btn.getClientRects().length === 0) {
      continue;
    }

    return btn;
  }

  return null;
}
